import { useEffect } from "react";

import { Action, Category } from "@/constants/events";
import { BrandLicense } from "@/custom-types/Brand";
import { useEventTracker } from "@/hooks/useEventTracker";

import OpenInNewIcon from "@/components/Icons/open_in_new.svg";
import WebsiteIcon from "@/components/Icons/website.svg";

import BrandLicenses from "../BrandLicenses";

const BrandAdditionalInfo = ({
  brandId,
  brandLicenses,
  informationWebsite,
  paidTier,
}: {
  brandId: number;
  brandLicenses: BrandLicense[] | [];
  informationWebsite: string | null;
  paidTier: boolean;
}) => {
  const { publishEvent } = useEventTracker();

  useEffect(() => {
    publishEvent({
      action: Action.impression,
      brandId,
      category: paidTier ? Category.brandPaid : Category.brandInfo,
      label: "additional info",
    });
  }, []);

  return (
    <div data-testid="brand_additional_info">
      <h2 className="heading--m">Additional information</h2>
      {brandLicenses && brandLicenses.length > 0 && (
        <BrandLicenses brandLicenses={brandLicenses} />
      )}
      {paidTier && informationWebsite && (
        <div className="flex icon--centered my-md text-green">
          <WebsiteIcon width="24" height="24" className="mr-sm" />
          <a
            data-testid={"brand_additional_info__visit_website"}
            onClick={() => {
              publishEvent({
                action: Action.click,
                brandId,
                category: Category.brandPaid,
                label: "outbound link",
              });
            }}
            href={informationWebsite}
            rel="sponsored"
            target="_blank"
            className="underline"
          >
            Visit website
          </a>
          <OpenInNewIcon width="24" height="24" className="ml-xs" />
        </div>
      )}
    </div>
  );
};

export default BrandAdditionalInfo;
